export default [
  {
    title: "Linhas afetadas pela redução do quadro de horários",
    message: (<>Redução afeta as linhas 03, 04, 05 e 07 do transporte público municipal de Sabará-MG, operadas pela Vinscol. Válido a partir de quinta-feira, 03<span className={"arial"}>/</span>04</>),
    init: "2025-04-03T00:00:00-03:00",
    finish: "2025-04-13T00:00:00-03:00",
  }, {
    title: "Linhas afetadas pela construção do PSF Siderúrgica e reparação na ponte para o bairro Mangueiras",
    message: (<>As obras de construção do posto de saúde próximo ao Terminal Rodoviário de Sabará e a reparação da ponte para o bairro Mangueiras afeta todas as linhas operadas pela Vinscol e as linhas 4970, 4987, 4988 e 4991. Atrasos podem ocorrer.</>),
    init: "2025-06-30T00:00:00-03:00",
    finish: "2025-07-10T00:00:00-03:00",
  }, {
    title: "Reajuste nas tarifas do sistema metropolitano",
    message: (<>Reajuste foi de quase 9% - o dobro da inflação. Confira aqui.</>),
    link: "/news/6",
    init: "2026-01-01T00:00:00-03:00",
    finish: "2026-01-25T00:00:00-03:00",
  }, {
    // T1DO - link para matéria
    title: "Novas linhas de novas cidades: Caeté e Nova Lima",
    message: (<>Visando a expansão do sistema, incluímos as linhas das cidades de Caeté e Nova Lima - as municipais, intermunicipais e metropolitanas.</>),
    // ATT - definir ano para 2026
    init: "3026-01-15T00:00:00-03:00",
    finish: "3026-01-30T00:00:00-03:00",
  }, {
    title: "Pressione para um transporte público gratuito - Busão 0800",
    message: (<>Já imaginou um país com transporte de graça todos os dias? Temos a chance de tirar esse sonho do papel no Brasil, mas pra isso acontecer, precisamos pressionar o Congresso pela aprovação do Sistema Único de Mobilidade.</>),
    link: "https://busao0800.com",
    init: "2026-05-25T00:00:00-03:00",
    finish: "2026-06-15T00:00:00-03:00",
  }, {
    title: "Remoção dos horários de partida para todas as linhas municipais",
    message: (<>Devido ao descumprimento dos horários divulgados, à redução das viagens realizadas e à insuficiência de informações confiáveis sobre os horários de partida das linhas municipais, optamos por remover de nossa plataforma todos os horários de partidas referentes às linhas operadas pela Vinscol.</>),
    link: "https://busao0800.com",
    init: "2026-06-10T00:00:00-03:00",
    finish: "2026-06-30T00:00:00-03:00",
  }, {
    title: "Jogo do Brasil em 29/06 - Copa do Mundo: Mudança no quadro de horários",
    message: (<>As linhas metropolitanas operarão até as 12h no quadro de horários de dia útil atípico e, a partir, das 12h01, quadro de horário de sábados. Para as linhas municipais não obtivemos informações.</>),
    link: "/news/12",
    init: "2026-06-28T00:00:00-03:00",
    finish: "2026-06-30T00:00:00-03:00",
  }
]
